export default __webpack_public_path__ + "static/media/Numbers_15.07bd5538.png";